import { render, staticRenderFns } from "./AddToponym.vue?vue&type=template&id=56c06e36&"
import script from "./AddToponym.vue?vue&type=script&lang=js&"
export * from "./AddToponym.vue?vue&type=script&lang=js&"
import style0 from "./AddToponym.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports